import { GetAllMaterials_allMaterials_edges_node_clippingPlanes } from '@src/app/generated/GetAllMaterials';
import { PortalVector3 } from '@src/app/model/portalVector3';
import { Plane } from 'three';

export class PortalPlane extends Plane {
  constructor(normal?: PortalVector3, constant?: number) {
    super(normal, constant);
  };

  static fromGql(gql: GetAllMaterials_allMaterials_edges_node_clippingPlanes): PortalPlane {
    return new PortalPlane(
      gql.normal ? PortalVector3.fromGql(gql.normal) : undefined,
      gql.constant
    );
  }
}
